// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const CANCEL_DROP_MODAL_COMPONENT_FOOTER_PROPS = {
    'data-testid': 'cancel-drop-modal-component-footer',
    'variant': VARIANTS.FooterVariantsType.ACTION_BUTTONS,
  },
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_GHOST_BUTTON_PROPS = {
    'data-testid': 'loading-footer-action-link',
    'type': 'SECONDARY_GHOST',
    'size': 'LARGE',
  },
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_ACTION_BUTTON_PROPS = {
    'data-testid': 'cancel-drop-modal-component-footer-action-button',
    'size': 'LARGE',
    'type': 'PRIMARY',
  };

export {
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_PROPS,
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_ACTION_BUTTON_PROPS,
  CANCEL_DROP_MODAL_COMPONENT_FOOTER_GHOST_BUTTON_PROPS,
};
